import React, { useCallback, useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';

import { Grid } from 'layouts';
import { Button, Form } from 'components';
import { FiltersContext } from 'contexts';

const useStyles = makeStyles((theme) => ({
  form: {
    width: '100%', // Fix IE 11 issue.
  },
  checkbox: {
    marginRight: '8px'
  },
  input: {
    width: 'calc(100% - 32px)',
    marginRight: '32px'
  },
  grid: {
    lineHeight: '64px',
  },
  alignRight: {
    textAlign: 'right'
  },
  menuItem: {
    minHeight: '36px'
  }
}));
const labels = {
  "blh": "BLHN",
  "vpgt": "FS"
};

const ProductsFilterSection = (props) => {
  const classes = useStyles();

  const {
    state: filtersState,
    actions: filtersActions
  } = useContext(FiltersContext);

  useEffect(() => {
    const { productsFilters, roles } = props;
    filtersActions.getBusinessUnits(productsFilters?.filters, roles);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.productsFilters?.filters, props.roles]);

  useEffect(() => {
    const { productsFilters, values } = props;
    filtersActions.getCategories(values.businessUnit, productsFilters?.schemes);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.values.businessUnit, props.productsFilters?.schemes]);

  const clearRefiners = () => {
    props.handleChange({ target: { name: 'specifiers', value: {} } });
    props.handleChange({ target: { name: 'pendingDatasheet', value: false } });
  }

  const changeAndSubmit = useCallback(event => {
    if (event?.target?.name === 'businessUnit') {
      props.handleChange({ target: { name: 'category', value: '' } });
      props.handleChange({ target: { name: 'specifier', value: '' } });
      clearRefiners();
    } else if (event?.target?.name === 'category') {
      props.handleChange({ target: { name: 'specifier', value: '' } });
      clearRefiners();
    }

    props.handleChange(event);
    props.submitForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Form className={classes.form} onSubmit={props.handleSubmit} noValidate>
      <Grid container>
        <Grid item xs={4}>
          <Form.TextField
            variant="outlined"
            margin="normal"
            select
            id="businessUnit"
            label="Business Unit"
            name="businessUnit"
            size="small"
            onChange={changeAndSubmit}
            className={classes.input}
            value={props.values.businessUnit}
          >
            {filtersState.businessUnits.map((option) => (
              <MenuItem className={classes.menuItem} key={option.value}
                        value={option.value}>
                {labels[option.label]??option.label}
              </MenuItem>
            ))}
          </Form.TextField>
        </Grid>
        <Grid item xs={4}>
          <Form.TextField
            variant="outlined"
            margin="normal"
            select
            id="category"
            label="Category"
            disabled={props.values.businessUnit === ''}
            name="category"
            size="small"
            onChange={changeAndSubmit}
            className={classes.input}
            value={props.values.category}
          >
            {filtersState.categories.map((option) => (
              <MenuItem className={classes.menuItem} key={option.value}
                        value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Form.TextField>
        </Grid>
        <Grid className={classes.grid} item xs={4}>
          <Button
            variant="contained"
            color="primary"
            disabled={
              props.values.businessUnit === '' || props.values.category === ''
            }
            className={classes.submit}
            onClick={() => props.history.push(
              `/products/${props.values.businessUnit}/${props.values.category}/new`
            )}
          >
            Create Product
          </Button>
          <Button
            variant="contained"
            color="primary"
            className={classes.submit}
            onClick={() => props.history.push(
              `/products-import`
            )}
          >
            Import Products
          </Button>
          <Button
            variant="contained"
            color="secondary"
            disabled={
              props.values.businessUnit === ''
            }
            className={classes.submit}
            onClick={props.onRemoveAll}
          >
            Remove All
          </Button>
        </Grid>
        {(props.values.businessUnit && props.values.category) && (
          <>
            <Grid item xs={8}>
              <Form.TextField
                variant="outlined"
                margin="normal"
                id="nameKeywords"
                label={"Product Name / Keywords" + (false && props.values.businessUnit === 'vpgt'?' / Product number':'')}
                name="nameKeywords"
                size="small"
                className={classes.input}
                onChange={props.handleChange}
                value={props.values.nameKeywords}
              />
            </Grid>
            <Grid className={classes.grid} item xs={1}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                className={classes.submit}
              >
                Search
              </Button>
            </Grid>
            {props.canApproveDatasheet && (
              <Grid className={[classes.grid, classes.alignRight]} item xs={3}>
                <Form.Checkbox
                  type="checkbox"
                  label={"Pending Datasheet"}
                  classesLabel={{root: classes.checkbox}}
                  name="pendingDatasheet"
                  fullWidth
                  checked={props.values.pendingDatasheet}
                  onChange={changeAndSubmit}
                />
              </Grid>
            )}
          </>
        )}
      </Grid>
    </Form>
  );
};

ProductsFilterSection.propTypes = {
  values: PropTypes.object,
  handleSubmit: PropTypes.func,
  handleChange: PropTypes.func,
  isSubmitting: PropTypes.bool,
  setSubmitting: PropTypes.func,
  onRemoveAll: PropTypes.func,
};

export default withRouter(ProductsFilterSection);
